import React, { useState, useEffect } from 'react';

import researchApi from "/src/apis/researchApi";
import { ALLOWED_QUERY_OPERATOR } from '/src/lib/constants';
import { getItemWebUrl } from '/src/lib/helpers';
import { prepareFilterParam, prepareSortParam } from '/src/lib/queryParams';



export const FilteredReports = (props) => {

    const { pageProps } = props;
    const isRegionPage  = (pageProps.type === 'region');
    const isInvestmentTypePage = (pageProps.type === 'investment_type');

    const { region_id, dataType } = pageProps;
    const [researchReports, setResearchReports] = useState([]);

    useEffect(() => {
        getResearchReports();
    }, []);

    const getResearchReports = async () => {

        let filterArray = [
            { 
                key: 'is_published', 
                value: [1], 
                op: ALLOWED_QUERY_OPERATOR.equal 
            },
        ];

        // TODO this is not an option as it only returns country specific reports in the given region
        // i.e. ignores MENA reports, SEA reports, etc.
        // if (isRegionPage) {
        //     filterArray.push({
        //         key: 'region_filter',
        //         value: region_id,
        //         op: ALLOWED_QUERY_OPERATOR.equal 
        //     })
        // }

        if (isRegionPage && region_id.length > 0) {
            let value = [dataType];
            if (dataType === "Southeast Asia") {
                value.push('SEA '); // space after to avoid reports with 'research' in the title
            }

            filterArray.push({
                key: 'keyword',
                value: value,
                op: ALLOWED_QUERY_OPERATOR.equal 
            })
        }

        if (isInvestmentTypePage) {
            let value = [dataType];
            if (dataType === "VC Investment") {
                value.push('VC', 'venture capital');
            } else if (dataType === "PE Investment") {
                value.push('PE ', 'private equity'); // space after PE to avoid words like 'landscape'
            }

            filterArray.push({
                key: 'keyword',
                value: value,
                op: ALLOWED_QUERY_OPERATOR.equal 
            })
        }

        const filters = prepareFilterParam(filterArray);

        const sort = prepareSortParam([
            { key: 'published_at', sortVal: 'desc' }
        ]);

        const limit = 8;

        researchApi.getResearchData(filters, limit, 1, sort).then((response) => {

            let research = response.records;
            for (let i in research) {

                // date
                if (research[i].published_at) {
                    let date = new Date(research[i].published_at)
                    let time = date.toLocaleString("en-US", { month: 'long', year: 'numeric' })
                    research[i].published_at = time;
                }

                let price = "";
                if (research[i].type_id == 1) {
                    if (research[i].price > 0) {
                        price = "$" + research[i].price;
                    } else {
                        price = "Premium Report";
                    }
                } else {
                    price = "Free Report";
                }
                research[i].displayPrice = price;

            }

            setResearchReports(research);

        })

    }

    const getSectionTitle = () => {
        let title = '';
        if (isRegionPage) {
            title = `Navigate ${dataType}'s Venture Scene`;
        } else if (isInvestmentTypePage) {
            if (dataType === 'Venture Debt') {
                title = `Navigate the ${dataType} Landscape`;
            } else {
                const dataTitleType = dataType == "PE Investment" ? "Private Equity" : "Venture Capital";
                title = `Navigate the ${dataTitleType} Landscape`;
            }
        }
        let heading = <>{title} with <span>Expert-Led Insights</span> and Real-World Context</>;
        return heading;
    }

    return (
        <div className="section-research-reports">

            <p className="landing-section-header">
                {getSectionTitle()}
            </p>

            <div className="row">
                {researchReports.map((item, i) => {
                    let itemUrl = getItemWebUrl('research', item.id, item.code);
                    return (
                        <div className={`col-md-6 col-lg-6 col-xl-3 ${i >= 4 ? 'hidden-sm-down' : ''}`} key={i}>
                            <div className="report-item" lang={item.lang}>
                                <div className="report-item-image border-bottom">
                                    <a href={`/${itemUrl}`} target="_blank">
                                        <img src={item.image_data.path} />
                                    </a>
                                </div>
                                <div className="report-item-text">
                                    <h6>
                                        <a href={`/${itemUrl}`} target="_blank">
                                            {item.name}
                                        </a>
                                    </h6>
                                    <div className="text-muted">{item.displayPrice} | {item.published_at}</div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>

            <div className="research-directory-link">
                <a className="red explore-all font-weight-bold" href="/research" target="_blank">
                    Explore Our Research
                </a>
            </div>

        </div>
    )

}